import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/use-auth';

export default function RequireAuth() {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <p className="text-sm text-textMuted">認証状態を確認中...</p>
      </div>
    );
  }

  if (!user) {
    const redirectTo = `${location.pathname}${location.search}`;
    const params = new URLSearchParams({ redirectTo });
    return <Navigate to={`/auth/sign-in?${params.toString()}`} replace />;
  }

  return <Outlet />;
}
